import { config } from '@/config';
import { capturePostHogEvent } from './posthog';

export type AnalyticsEventParams = Record<string, string | number | boolean | null | undefined>;

type GtagFunction = (
  command: 'event',
  eventName: string,
  params?: Record<string, string | number | boolean | null | undefined>,
) => void;

const getGtag = (): GtagFunction | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return (window as Window & { gtag?: GtagFunction }).gtag;
};

export const trackAnalyticsEvent = (eventName: string, params: AnalyticsEventParams = {}): void => {
  const normalizedParams = Object.fromEntries(
    Object.entries({
      app_name: config.analytics.appName,
      ...params,
    }).filter(([, value]) => value !== undefined),
  ) as AnalyticsEventParams;

  const gtag = getGtag();
  if (gtag) {
    gtag('event', eventName, normalizedParams);
  }

  capturePostHogEvent(eventName, normalizedParams);
};

export {
  initPostHog,
  capturePostHogEvent,
  identifyPostHogUser,
  resetPostHog,
  stripUrlQueriesBeforeSend,
} from './posthog';
